import * as api from '@/http'

export const ActionSetEmployees = async ({ commit }) => {
  try {
    const employees = await api.http.get('dash/employees/department').then(
      (response) => response.body,
      (error) => error
    )
    commit('SET_employees', employees)
  } catch (error) {}
}

export const ActionSetBirthdays = async ({ commit }) => {
  try {
    const birthdays = await api.http
      .get('dash/employees/birthdays')
      .then((response) => response.body)
    commit('SET_birthdays', birthdays)
  } catch (error) {}
}

export const ActionSetContactMessageWebSite = async ({ commit }) => {
  try {
    const messages = await api.http
      .get('dash/utils/rh_messages_contact_form')
      .then((response) => response.body)
    commit('SET_contactMessagesWebSite', messages)
  } catch (error) {}
}

export const ActionStoreEmployee = async ({ commit }, data) => {
  try {
    const employees = await api.http
      .post('dash/users/employees', data)
      .then((response) => response.body)
    commit('SET_employees', employees)
  } catch (error) {}
}

export const ActionGetPaycheckEmployee = async ({ commit }, employee_id) => {
  const paycheck = await api.http
    .get(`employees/paycheck/${employee_id}`)
    .then((response) => response.body)
  commit('SET_paychecks', paycheck)
}

export const ActionSetEmployeeScales = async ({ commit }) => {
  const employee_scales = await api.http
    .get('dash/employees/scales')
    .then((response) => response.data)
  commit('SET_employee_scales', employee_scales)
}

export const ActionSetEmployeeSwaps = async ({ commit }) => {
  const employee_swaps = await api.http.get('dash/scales/swaps').then((response) => response.data)
  commit('SET_employee_swaps', employee_swaps)
}

export const ActionSetIncomeTaxes = async ({ commit }) => {
  const income_taxes = await api.http
    .get('dash/employees/income_tax')
    .then((response) => response.data)
  commit('SET_income_taxes', income_taxes)
}

export const ActionDownloadPaycheck = async ({}, id) => {
  const request = await api.http
    .post(
      'employees/paycheck/download',
      { id },
      {
        responseType: 'arraybuffer',
      }
    )
    .then((response) => donwloadPDF(response.data))
}

export const ActionDownloadIncomeTaxPDF = async ({}, id) => {
  const request = await api.http
    .post(
      `dash/employees/income_tax/${id}`,
      {},
      {
        responseType: 'arraybuffer',
      }
    )
    .then((response) => donwloadPDF(response.data))
}

function donwloadPDF(data) {
  var out = new Blob([data], { type: 'application/pdf' })
  var _global =
    typeof window === 'object' && window.window === window
      ? window
      : typeof self === 'object' && self.self === self
      ? self
      : typeof global === 'object' && global.global === global
      ? global
      : this

  var force = out.type === 'application/octet-stream'
  var isSafari = /constructor/i.test(_global.HTMLElement) || _global.safari
  var isChromeIOS = /CriOS\/[\d]+/.test(navigator.userAgent)
  var isMacOSWebView =
    /Macintosh/.test(navigator.userAgent) &&
    /AppleWebKit/.test(navigator.userAgent) &&
    !/Safari/.test(navigator.userAgent)

  if ((isChromeIOS || (force && isSafari) || isMacOSWebView) && typeof FileReader !== 'undefined') {
    // Safari doesn't allow downloading of blob URLs
    var reader = new FileReader()
    reader.onload = function (e) {
      window.location.href = reader.result
    }
    reader.readAsDataURL(out)
  } else {
    var URL = _global.URL || _global.webkitURL
    var url = URL.createObjectURL(out)
    location.href = url
    setTimeout(function () {
      URL.revokeObjectURL(url)
    }, 2000)
  }
}
